import React, {Component} from 'react'
import Head from 'next/head'
import LandingPromo from '../../components/LandingPromo'
import ArticlesSection from '../../components/ArticlesSection/index'
import ArticlesCarouselPreview from '../../components/ArticlesCarouselPreview/ArticlesCarouselPreview'
import {SITE_META_TITLE, socialMeta} from '../../data/meta'
import {getEnvHostAddress} from 'shared/env'
import {LearnvestApi} from 'client/api/learnvest'

class LandingPage extends Component {
  loadMoreArticles (size, page) {
    const lvapi = new LearnvestApi()
    return lvapi.fetchArticles(null, null, page - 4, 12)
  }

  render () {
    const {featuredArticles, mustReadArticles, latestArticles, totalArticles} = this.props
    return (
      <div className='LandingPage'>
        <Head>
          <title>{SITE_META_TITLE}</title>
          <link rel='canonical' href={getEnvHostAddress()} />
          <meta name='google-site-verification' content='lLFjbYV2vlfER8zsgCiE4uqpDoqF3FJb1p6xU_lf8_0' />
          {socialMeta()}
        </Head>
        <LandingPromo articles={featuredArticles} />
        <ArticlesSection
          mobileOffset={6}
          totalArticles={totalArticles}
          articles={latestArticles}
          className='LandingPage__articles'
          title={'Must Reads'}
          loader={this.loadMoreArticles}
        />
        <ArticlesCarouselPreview articles={mustReadArticles} className='LandingPage__carousel' />
      </div>
    )
  }
}

LandingPage.defaultProps = {}

export default LandingPage



// WEBPACK FOOTER //
// ./client/pageComponents/LandingPage/LandingPage.js